import { Maximize2, Minimize2 } from 'lucide-react'
import { fullscreenTileVideo, useFullscreenHost } from '@/lib/fullscreen'

/**
 * «Во весь экран» у плитки с видео. Когда плитка развёрнута, это «Свернуть» с подписью: значок в углу
 * там легко не найти (выйти можно и по Esc).
 */
export function TileFullscreenButton({ userId, className }: { userId: string; className?: string | undefined }) {
  const host = useFullscreenHost()
  const full = host?.getAttribute('data-user-id') === userId
  return (
    <button type="button" className={className} data-tooltip={full ? 'Свернуть (Esc)' : 'Во весь экран'} aria-label={full ? 'Свернуть' : 'Во весь экран'} onClick={fullscreenTileVideo}>
      {full ? <><Minimize2 size={18} /> Свернуть</> : <Maximize2 size={16} />}
    </button>
  )
}
